import service from '@/services';

const buscarRegionais = async (paginaAtual, itensPerPage, searchQuery) => {
  try {
    const result = await service.getFilterPagination(
      `Regional`,
      {
        page: paginaAtual,
        limit: itensPerPage,
        search: searchQuery,
      },
      'listPAginada',
    );
    return result;
  } catch (err) {
    throw err;
  }
};

export default {
  buscarRegionais,
};
